import { createApi } from '@reduxjs/toolkit/query/react';
import { AdminRole, GetAdminRolesResponse } from '../../resources/types/adminRolesTypes';
import baseQuery from './baseQuery';

export interface CreateAdminRoleBody {
  id: string;
  name: string;
  tabs: string[];
  icon: string;
}

export interface UpdateAdminRoleBody {
  name: string;
  tabs: string[];
  icon: string;
}

export const adminRolesApi = createApi({
  reducerPath: 'adminRolesApi',
  baseQuery,
  tagTypes: ['AdminRole'],
  endpoints: builder => ({
    getAdminRoles: builder.query<AdminRole[], void>({
      query: () => 'admin_roles',
      transformResponse(response: GetAdminRolesResponse) {
        console.log('=== GET /admin_roles response:', response);
        return response.data || [];
      },
      providesTags: ['AdminRole']
    }),
    createAdminRole: builder.mutation<AdminRole, CreateAdminRoleBody>({
      query: (body) => ({
        url: 'admin_roles',
        method: 'POST',
        body
      }),
      invalidatesTags: ['AdminRole']
    }),
    updateAdminRole: builder.mutation<AdminRole, { id: string; body: UpdateAdminRoleBody }>({
      query: ({ id, body }) => ({
        url: `admin_roles/${id}`,
        method: 'PUT',
        body
      }),
      invalidatesTags: ['AdminRole']
    }),
    deleteAdminRole: builder.mutation<void, string>({
      query: (id) => ({
        url: `admin_roles/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['AdminRole']
    })
  })
});

export const { 
  useGetAdminRolesQuery, 
  useCreateAdminRoleMutation,
  useUpdateAdminRoleMutation,
  useDeleteAdminRoleMutation
} = adminRolesApi;
